import { Button, Table } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { apiUrl } from '../../config'
import SingularParameterModal from '../ModalComponent/ConstraintModal/SingularParameterModal'
import { useTranslation } from 'react-i18next'

const SingularParameters = () => {
    const { t } = useTranslation()


    const [allData, setAllData] = useState([])
    const [modifiedData, setModifiedData] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedRow, setSelectedRow] = useState([])
    const [refreshPage, setRefreshPage] = useState(false)
    const [rule, setRule] = useState("")
    const username = process.env.REACT_APP_USERNAME;
    const password = process.env.REACT_APP_SECRET_KEY;

    const getData = () => {
        axios.get(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/getSingularParameter`, {
            auth: {
                username: username,
                password: password
            }
        })
            .then(res => setAllData(res.data))
            .catch(err => console.log(err))
    }

    useEffect(() => {
        getData()
    }, [refreshPage])

    const handleClick = (record) => {
        setSelectedRow(record)
        setModalOpen(true)
        setRule("changeOrder")
    }
    useEffect(() => {
        const dataList = allData?.map((item, index) => ({
            key: index + 1,
            hds_capacity: item?.hds_capacity,
            hds_efficiency: item?.hds_efficiency,
            hds_low_limit: item?.hds_low_limit,

        }));

        setModifiedData([...dataList]);
    }, [allData]);

    const columns = [
        {
            title: t("singularParameters.parameter"),
            dataIndex: "parameter",
            align: "center",
            width: 120,
        },
        {
            title: t("singularParameters.value"),
            dataIndex: "value",
            width: 90,
            align: "center",
        },

    ];

    const parameterLabels = {
        'hds_capacity': t('singularParameters.hdsCapacity'),
        "hds_efficiency": t("singularParameters.hdsEfficiency"),
        'hds_low_limit': t('singularParameters.hdsLowLimit'),
        'hds_high_limit': t('singularParameters.hdsHighLimit'),
        'yer1_inventory_capacity': t('singularParameters.yer1InventoryCapacity'),
        'yer2_inventory_capacity': t('singularParameters.yer2InventoryCapacity'),
        'num_frozen_period': t('singularParameters.numFrozenPeriod'),
        'min_lot_size': t('singularParameters.minLotSize'),
        'par_asma_toplama': t('singularParameters.parAsmaToplama'),
        'parColorChangePenalty': t("singularParameters.parColorChangePenalty"),
        'parMaterialGroupingPenalty': t("singularParameters.parMaterialGroupingPenalty"),
        'parEndStockPenalty': t('singularParameters.parEndStockPenalty'),
        'parSafetyUsagePenalty': t('singularParameters.parSafetyUsagePenalty'),
        'parLowStockPenalty': t('singularParameters.parLowStockPenalty'),
        'parGovdeLowStockPen': t('singularParameters.parGovdeLowStockPen'),
        'parGovdeOnLowStockPen': t('singularParameters.parGovdeOnLowStockPen'),
        'parChosenStopCoef': t('singularParameters.parChosenStopCoef'),


    };


    const prepareTableData = (rawData, isLeftTable) => {
        if (!Array.isArray(rawData)) {
            console.error('Data is not an array');
            return [];
        }

        return rawData.map((item, index) => {
            const rows = [];
            Object.keys(item).forEach(key => {
                if (
                    (isLeftTable && (
                        key === 'hds_capacity' ||
                        key === 'hds_efficiency' ||
                        key === 'hds_low_limit' ||
                        key === 'hds_high_limit' ||
                        key === 'yer1_inventory_capacity' ||
                        key === 'yer2_inventory_capacity' ||
                        key === 'num_frozen_period' ||
                        key === 'min_lot_size' ||
                        key === 'par_asma_toplama'
                    )) ||
                    (!isLeftTable && (
                        key === 'parColorChangePenalty' ||
                        key === 'parMaterialGroupingPenalty' ||
                        key === 'parEndStockPenalty' ||
                        key === 'parSafetyUsagePenalty' ||
                        key === 'parLowStockPenalty' ||
                        key === 'parGovdeLowStockPen' ||
                        key === 'parGovdeOnLowStockPen' ||
                        key === 'parChosenStopCoef'
                    ))
                ) {
                    rows.push({
                        key: `${index + 1}-${key}`,
                        parameter: parameterLabels[key] || key,
                        value: item[key],
                    });
                }
            });
            return rows;
        }).flat();
    };



    useEffect(() => {
        const dataList = allData?.map((item, index) => ({
            key: index + 1,
            ...item,
        }));
        const leftTableData = prepareTableData(dataList, true);
        const rightTableData = prepareTableData(dataList, false);
        setModifiedData([leftTableData, rightTableData]);
    }, [allData]);



    return (
        <div style={{ maxHeight: '82vh', overflowY: 'auto' }}>
            <SingularParameterModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                modifiedData={modifiedData}
                selectedRow={selectedRow}
                rule={rule}
                setRefreshPage={setRefreshPage}
                refreshPage={refreshPage}
                allData={allData}
            />
            <div className="flex p-4 flex-col h-full gap-2 ">
                <div className='flex w-max bg-smartopt rounded-lg'>
                    <Button className='text-white font-semibold w-44' onClick={() => {
                        setModalOpen(true)
                        setRule("newOrder")
                    }}>
                        {t("singularParameters.change")}

                    </Button>
                </div>
                <div className='flex flex-row gap-3'>
                    <div className="tableAsma flex h-full overflow-auto w-full">
                        <Table
                            bordered
                            sticky
                            dataSource={modifiedData[0]} // Left table data
                            columns={columns}
                            scroll={{ x: 700 }}
                            pagination={{ pageSize: 10 }}
                        />
                    </div>
                    <div className="tableAsma flex h-full overflow-auto w-full">
                        <Table
                            bordered
                            sticky
                            dataSource={modifiedData[1]} // Right table data
                            columns={columns}
                            scroll={{ x: 700 }}
                            pagination={{ pageSize: 10 }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SingularParameters